<template>
<div id="ccLogin">
  <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

  <div class="container">
  <div class="row">
  <div class="col-md-4 offset-md-4" style="border:10px solid #171a26; background:rgba(19,21,31,0.7); margin-top:50px; padding:50px 0 50px 0; border-radius: 15px;">

    <section>
      <div class="row">
        <div class="col-10 offset-1">

            <p class="text-center">
                <img :src='"../../assets/image/logo_sokker.png"' alt="Responsive image" :title='"sokkerduel"' width="180px">
            </p>

            <div v-show="box_alert" class="mt-5 mb-5">
              <div class="alert alert-dismissible fade show text-center" v-bind:class="[box_cor==0?'alert-danger':'alert-success']" role="alert">
                <strong>{{this.box_alert_text}}</strong>
              </div>
            </div>

            <!-- tela1 ------ -->
            <div v-show="tela1" class="tes">
              <p class="text-center"><router-link to="/login" style="color: #fff;">Voltar</router-link></p>
            </div>

            <!-- tela2 ------ -->
            <div v-show="tela2">
                <div class="input-group mb-4">
                  <input type="password" v-model="senha" class="form-control" placeholder="Senha" required>
                </div>

                <div class="input-group mb-4">
                  <input type="password" v-model="senha_aux" class="form-control" placeholder="Repetir Senha" required>
                </div>

                <div class="row">
                  <div class="col-12">
                    <button type="submit" class="btn w-100 text_15 text_bold mt_5 btn-success" @click="save()">
                      SALVAR SENHA
                    </button>
                  </div>
                </div>
            </div>

        </div>
      </div>
    </section>

  </div>
  </div>
  </div>

</div>
</template>

<script>

var basehost = process.env.BASE_HOST;
var base_url_api = process.env.BASE_URL_API;
import axios from 'axios'
import ccLoading from '../cc_geral/cc_loading.vue'
import { RouterLink } from 'vue-router';

export default {

  data () {
    return {
      token: null,
      loading: false,
      box_alert: false,
      box_alert_text: null,
      box_cor: 0,
      tela1: true,
      tela2: false,
      senha: null,
      senha_aux: null,
    }
  },

  components: {ccLoading, RouterLink },

  created()
  {
    localStorage.setItem("base_url_api_mobile", base_url_api);

    this.token = this.$route.params.token

    this.carregue()
  },

  methods: {

    async carregue(){
      var body = {
        token: this.token,
      };

      this.loading = true

      axios.post(base_url_api + 'esqueceu/senha/validar', body)
      .then(response => {
        if (response.status === 200) {
          if (response.data.status === 'success') {
            this.tela1 = false
            this.tela2 = true
          }
        }

        this.loading = false;
      })
      .catch(error => {

        if (error.response && error.response.status === 500 && error.response.data) {
          let slugValue = error.response.data[0].slug;

          if(slugValue == 'user_not_found') { slugValue = 'Token inválido!'}
          if(slugValue == 'token_usado') { slugValue = 'Token expirado!'}

          this.box_alert_text = slugValue
          this.box_cor = 0
          this.box_alert = true;
        } else {
          console.log(error.response.status);
        }

        this.loading = false;
      });
    },

    async save(){

      if(this.senha_aux == null || this.senha_aux == '' || this.senha == null || this.senha == ''){
        this.box_alert_text = "Senhas não preechidas!";
        this.box_cor = 0
        this.box_alert = true;
        return;
      }

      if(this.senha_aux != this.senha ){
        this.box_alert_text = "Senhas não são iguais!";
        this.box_cor = 0
        this.box_alert = true;
        return;
      }

      var body = {
        token: this.token,
        senha: this.senha,
      };

      this.loading = true

      axios.post(base_url_api + 'esqueceu/senha/redefinir/save', body)
      .then(response => {
        if (response.status === 200) {
          if (response.data.status === 'success') {

            this.box_alert_text = "Senhas redefinida!";
            this.box_cor = 1
            this.box_alert = true;

            this.tela1 = true
            this.tela2 = false
          }
        }

        this.loading = false;
      })
      .catch(error => {

        if (error.response && error.response.status === 500 && error.response.data) {
          const slugValue = error.response.data[0].slug;
          this.box_alert_text = slugValue;
          this.box_alert = true;
        } else {
          console.log(error.response.status);
        }

        this.loading = false;
      });


    },



  },

}
</script>


// WEBPACK FOOTER //
// src/components/login/esqueceu_senha_validar.vue